import http from "../../httpService";
import { apiUrl } from "../../../../config.js";

const apiEndpoint = apiUrl + "/setup/inventory/items/";

export function getCategoriesTree() {
  return http.get(apiEndpoint + "categories-tree");
}

export function getCategories() {
  return http.get(apiEndpoint + "categories");
}

export function getSubCategories(categoryID) {
  return http.get(apiEndpoint + "sub-categories/" + categoryID);
}

export function getItemCategories(subCategoryID) {
  return http.get(apiEndpoint + "item-categories/" + subCategoryID);
}

export function getBrands() {
  return http.get(apiEndpoint + "brands");
}

export function getUoms() {
  return http.get(apiEndpoint + "uoms");
}

export function getVariants() {
  return http.get(apiEndpoint + "variants");
}

export function saveCategory(category) {
  return httpSaveData("category", category);
}

export function saveSubCategory(subCategory) {
  return httpSaveData("sub-category", subCategory);
}

export function saveItemCategory(itemCategory) {
  return httpSaveData("item-category", itemCategory);
}

export function deleteCategory(categoryID) {
  return http.delete(apiEndpoint + "category/" + categoryID);
}

export function deleteSubCategory(subCategoryID) {
  return http.delete(apiEndpoint + "sub-category/" + subCategoryID);
}

export function deleteItemCategory(itemCategoryID) {
  return http.delete(apiEndpoint + "item-category/" + itemCategoryID);
}

export function saveBrand(brand) {
  return httpSaveData("brand", brand);
}

export function saveUom(uom) {
  return httpSaveData("uom", uom);
}

export function saveVariant(variant) {
  return httpSaveData("variant", variant);
}

export function deleteBrand(itemBrandID) {
  return http.delete(apiEndpoint + "brand/" + itemBrandID);
}

export function deleteUom(uomID) {
  return http.delete(apiEndpoint + "uom/" + uomID);
}

export function deleteVariant(itemVariantID) {
  return http.delete(apiEndpoint + "variant/" + itemVariantID);
}

function httpSaveData(path, data) {
  if (data.ID === 0) {
    return http.post(apiEndpoint + path, data);
  } else {
    return http.put(apiEndpoint + path, data);
  }
}
